/**
 * generate breadcrumb content based on category name
 */
const generateBreadcrumbCategory = (breadcrumbName) => {
  let breadcrumbCategory = breadcrumbName;
  if (breadcrumbName && breadcrumbName.includes('-')) {
    breadcrumbCategory = breadcrumbName.split('-').join(' ');
    return breadcrumbCategory;
  } else {
    return breadcrumbCategory;
  }
};

export default generateBreadcrumbCategory;
